import { Subscriber } from 'rxjs';

export function removeDefaultHandler(err: {
  defaultHandler: Subscriber<unknown>;
  networkError: { defaultHandler: Subscriber<unknown> };
}) {
  // Created by error-handler interceptor
  err.defaultHandler?.unsubscribe();
  // Apollo mutates the err to donwstream subs to be in this format
  // They do not make it possible to change this mutation
  err.networkError?.defaultHandler?.unsubscribe();
}
